import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Form, Input, Button, Icon, message } from 'antd';
import styled from 'styled-components';

var Section = styled.div`
  margin-bottom: 32px;
  &:last-child { margin-bottom: 0; }
`;

var SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
`;

var SectionIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: ${function(p) { return p.bg || '#fff7e6'; }};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  .anticon { font-size: 16px; color: ${function(p) { return p.color || '#fa8c16'; }}; }
`;

var SectionTitle = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: #262626;
`;

var SectionDescription = styled.div`
  font-size: 12px;
  color: #8c8c8c;
  margin-top: 1px;
`;

var FormCard = styled.div`
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 20px 24px;
  .ant-form-item { margin-bottom: 16px; }
  .ant-form-item:last-child { margin-bottom: 0; }
  .ant-form-item-label { line-height: 1.5; padding-bottom: 4px; }
  .ant-form-item-label label { font-size: 13px; font-weight: 500; color: #595959; }
  .ant-input { border-radius: 6px; height: 40px; font-size: 14px; }
  .ant-input-password { .ant-input { height: 40px; font-size: 14px; } }
`;

var FooterBar = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  width: 1100px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 12px 24px;
  background: #fff;
  border-top: 1px solid #f0f0f0;
  z-index: 1020;

  .ant-btn {
    height: 44px;
    font-size: 15px;
    padding: 0 32px;
    border-radius: 8px;
  }
`;

var PasswordHint = styled.div`
  font-size: 11px;
  color: #8c8c8c;
  margin-top: -8px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 4px;

  .anticon {
    font-size: 12px;
    color: #bfbfbf;
  }
`;


var ChangePasswordForm = function(props) {
  var form = props.form;
  var changePassword = props.changePassword;
  var getFieldDecorator = form.getFieldDecorator;
  var confirmDirtyState = useState(false);
  var confirmDirty = confirmDirtyState[0];
  var setConfirmDirty = confirmDirtyState[1];
  var currentPasswordState = useState({});
  var currentPassword = currentPasswordState[0];
  var setCurrentPassword = currentPasswordState[1];
  var savingState = useState(false);
  var isSaving = savingState[0];
  var setIsSaving = savingState[1];

  var handleSubmit = function(e) {
    e.preventDefault();
    setCurrentPassword({});
    form.validateFieldsAndScroll(function(err, values) {
      if (!err) {
        setIsSaving(true);
        changePassword(values)
          .then(function() {
            form.resetFields();
            message.success('Senha alterada com sucesso!');
          })
          .catch(function(response) {
            var errors = response && response.error && response.error.response && response.error.response.data && response.error.response.data.errors;
            setCurrentPassword({
              validateStatus: 'error',
              help: errors && errors.current_password && errors.current_password[0] || 'Senha atual incorreta'
            });
          })
          .finally(function() {
            setIsSaving(false);
          });
      }
    });
  };

  var handleConfirmBlur = function(e) {
    var value = e.target.value;
    setConfirmDirty(confirmDirty || !!value);
  };

  var compareToFirstPassword = function(rule, value, callback) {
    if (value && value !== form.getFieldValue('password')) {
      callback('As senhas não conferem!');
    } else {
      callback();
    }
  };

  var validateToNextPassword = function(rule, value, callback) {
    if (value && confirmDirty) {
      form.validateFields(['password_confirm'], { force: true });
    }
    callback();
  };

  return (
    <Form layout="vertical" onSubmit={handleSubmit}>
      <Section>
        <FormCard>
          <Form.Item label="Senha Atual" {...currentPassword}>
            {getFieldDecorator('current_password', {
              rules: [{ required: true, message: 'Informe sua senha atual' }],
            })(<Input.Password placeholder="Digite sua senha atual" prefix={<Icon type="lock" style={{ color: '#bfbfbf' }} />} />)}
          </Form.Item>
          <Form.Item label="Nova Senha">
            {getFieldDecorator('password', {
              rules: [
                { required: true, message: 'Informe a nova senha' },
                { min: 6, message: 'A senha deve ter pelo menos 6 caracteres' },
                { validator: validateToNextPassword },
              ],
            })(<Input.Password placeholder="Digite a nova senha" prefix={<Icon type="key" style={{ color: '#bfbfbf' }} />} />)}
          </Form.Item>
          <PasswordHint>
            <Icon type="info-circle" />
            Mínimo 8 caracteres, com maiúsculas, minúsculas e números
          </PasswordHint>
          <Form.Item label="Confirmar Nova Senha">
            {getFieldDecorator('password_confirm', {
              rules: [
                { required: true, message: 'Confirme a nova senha' },
                { validator: compareToFirstPassword },
              ],
            })(<Input.Password placeholder="Repita a nova senha" onBlur={handleConfirmBlur} prefix={<Icon type="check-circle" style={{ color: '#bfbfbf' }} />} />)}
          </Form.Item>
        </FormCard>
      </Section>
      <FooterBar>
        <Button type="primary" htmlType="submit" loading={isSaving} icon="save">
          Salvar
        </Button>
      </FooterBar>
    </Form>
  );
};

var mapDispatchProps = function(dispatch) {
  return {
    changePassword: function(data) {
      return dispatch({
        type: 'CHANGE_PASSWORD',
        payload: {
          request: {
            method: 'patch',
            url: '/user/password',
            data: data
          }
        }
      });
    }
  };
};

export default connect(null, mapDispatchProps)(Form.create()(ChangePasswordForm));
